import { createContext, useContext, useEffect, useState } from "react";
import api, { errMsg } from "@/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("fwd_token", data.access_token);
      const me = await api.get("/auth/me");
      setUser(me.data);
      return { ok: true, user: me.data };
    } catch (e) {
      return { ok: false, error: errMsg(e) };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* noop */
    }
    localStorage.removeItem("fwd_token");
    setUser(false);
  };

  const can = (perm) =>
    !!user && (user.permissions?.includes("*") || user.permissions?.includes(perm));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
